var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83325 5.8335H6.07675C6.50666 5.8335 6.722 5.8335 6.89734 5.91106C7.05194 5.97944 7.18412 6.08954 7.27943 6.22916C7.38736 6.38725 7.42633 6.59835 7.50413 7.01973L9.46292 17.6298L18.9197 17.6298C19.3309 17.6298 19.5372 17.6298 19.7075 17.5571C19.858 17.4929 19.9878 17.389 20.0842 17.2568C20.1931 17.1073 20.2393 16.9072 20.3316 16.5074L20.3323 16.5046L21.7562 10.3342L21.7565 10.3329C21.8965 9.72642 21.9666 9.42243 21.8896 9.18399C21.822 8.97478 21.6798 8.7974 21.4911 8.6845C21.2759 8.55572 20.965 8.55572 20.3415 8.55572H8.10177M19.4444 22.1668C18.9432 22.1668 18.537 21.7606 18.537 21.2594C18.537 20.7583 18.9432 20.352 19.4444 20.352C19.9455 20.352 20.3518 20.7583 20.3518 21.2594C20.3518 21.7606 19.9455 22.1668 19.4444 22.1668ZM10.3703 22.1668C9.86914 22.1668 9.46288 21.7606 9.46288 21.2594C9.46288 20.7583 9.86914 20.352 10.3703 20.352C10.8714 20.352 11.2777 20.7583 11.2777 21.2594C11.2777 21.7606 10.8714 22.1668 10.3703 22.1668Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart-icon.b597dcd1c6e79108567c41092ed49152.svg";
export { ForwardRef as ReactComponent };